import type { ToastType } from '@common/utils/notify/notify.types';
import { createAction, createActionGroup, props } from '@ngrx/store';
import { type IndividualConfig } from 'ngx-toastr';

/**
 * @deprecated The method should not be used, use `NotifyActions.showNotify` instead
 */
export const showNotify = createAction(
    '[NOTIFY] Show noty',
    props<{ toastType: ToastType; message: string; title?: string; config?: Partial<IndividualConfig> }>()
);

const NotifyActions = createActionGroup({
    source: 'Notify',
    events: {
        'Show Notify': props<{
            toastType: ToastType;
            message: string;
            title?: string;
            config?: Partial<IndividualConfig>;
        }>(),
    },
});

export default NotifyActions;
